/** A suggestion the recruiter clicked, waiting in the composer to be sent. */
export type SelectedSuggestion = {
  text: string;
  /** Only on a removal suggestion: the field its send removes. */
  field?: string;
};

/**
 * A suggestion is its text and its field together: two removal suggestions can
 * read the same and name different fields.
 */
export const isSameSuggestion = (
  a: SelectedSuggestion,
  b: SelectedSuggestion
): boolean => a.text === b.text && a.field === b.field;

/**
 * The tag a suggestion is sent as. A removal suggestion carries its field, as
 * the agent writes it, so a regenerated turn can send the removal again.
 */
export const toSuggestionTag = (suggestion: SelectedSuggestion): string =>
  suggestion.field
    ? `<specific_suggestion field="${suggestion.field}">${suggestion.text}</specific_suggestion>`
    : `<specific_suggestion>${suggestion.text}</specific_suggestion>`;

export const suggestionKey = (suggestion: SelectedSuggestion): string =>
  `${suggestion.field ?? ''}:${suggestion.text}`;
